import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
function ManagerRoutes () {
  const { token, user } = useSelector(state => state.auth)

  const redirectTo = role_id => {
    switch (parseInt(role_id)) {
      case 1:
        return '/manager/accounts'
      default:
        return '/login'
    }
  }

  const getRedirectPath = () => {
    if (!token) return '/login'
    return redirectTo(user?.role_id)
  }
  return user?.role_id == 1 ? <Outlet /> : <Navigate to={getRedirectPath()} />
}

export default ManagerRoutes
